import {
  Card,
  CardContainer,
  CardContent,
  CardHeader,
  CardHeading,
  HeaderCard,
  HeaderCardHeading,
  HeaderCardIntro,
} from 'components/ui/cards';
import { CImage } from 'components/ui/CImage';
import { LinkArrow, LinkUnstyled } from 'components/ui/links';
import { ResumeExampleGroupFieldsFragment as ResumeExampleGroup } from 'graphql/generated/sdk';

type Props = {
  activeGroup: ResumeExampleGroup;
};

export default function ResumeTemplates({ activeGroup }: Props) {
  return (
    <CardContainer
      sx={{
        mt: [50, 50, 100, 100],
        mb: [100, 100, 150, 200],
      }}
    >
      <HeaderCard>
        <HeaderCardHeading>Resume Templates</HeaderCardHeading>
        <HeaderCardIntro>
          Hiring manager approved {activeGroup.menuTitle} resume templates.
          <LinkArrow
            href="/resume-templates"
            text="titleEmphasis"
            sx={{ mt: 8 }}
          >
            View all templates
          </LinkArrow>
        </HeaderCardIntro>
      </HeaderCard>

      <Card column={[12, 6]} isDark sx={{ background: 'rgb(19, 63, 123)' }}>
        <CardHeader>
          <CardHeading>Professional</CardHeading>
          <LinkArrow
            href="/resume-templates/professional"
            sx={{ color: 'text' }}
            arrowColor="text"
          >
            View professional templates
          </LinkArrow>
        </CardHeader>
        <CardContent sx={{ pb: 0, pt: 16 }}>
          <LinkUnstyled href="/resume-templates/professional">
            <CImage
              alt={`Professional ${activeGroup.menuTitle} resume template`}
              htmlWidth={1800}
              htmlHeight={1467}
              sizes="(max-width: 768px) 100vw, (max-width: 1440px) 47vw, 684px"
              srcSetSizes={[375, 750, 1125, 1368]}
              id="resume-templates/parker/professional-resume-template-software-engineer.png"
              loading="lazy"
              sx={{ display: 'block' }}
            />
          </LinkUnstyled>
        </CardContent>
      </Card>

      <Card column={[12, 6]} isDark sx={{ background: 'rgb(115, 19, 231)' }}>
        <CardHeader>
          <CardHeading>Modern</CardHeading>
          <LinkArrow
            href="/resume-templates/modern"
            sx={{ color: 'text' }}
            arrowColor="text"
          >
            View modern templates
          </LinkArrow>
        </CardHeader>
        <CardContent sx={{ pb: 0, pt: 16 }}>
          <LinkUnstyled href="/resume-templates/modern">
            <CImage
              alt={`Modern ${activeGroup.menuTitle} resume template`}
              htmlWidth={1800}
              htmlHeight={1467}
              sizes="(max-width: 768px) 100vw, (max-width: 1440px) 47vw, 684px"
              srcSetSizes={[375, 750, 1125, 1368]}
              id="resume-templates/pender/modern-resume-template-ios-developer.png"
              loading="lazy"
              sx={{ display: 'block' }}
            />
          </LinkUnstyled>
        </CardContent>
      </Card>

      <Card column={[12, 6]} isDark sx={{ background: 'rgb(164, 101, 229)' }}>
        <CardHeader>
          <CardHeading>Creative</CardHeading>
          <LinkArrow
            href="/resume-templates/creative"
            sx={{ color: 'text' }}
            arrowColor="text"
          >
            View creative templates
          </LinkArrow>
        </CardHeader>
        <CardContent sx={{ pb: 0, pt: 16 }}>
          <LinkUnstyled href="/resume-templates/creative">
            <CImage
              alt={`Creative ${activeGroup.menuTitle} resume template`}
              htmlWidth={1800}
              htmlHeight={1467}
              sizes="(max-width: 768px) 100vw, (max-width: 1440px) 47vw, 684px"
              srcSetSizes={[375, 750, 1125, 1368]}
              id="resume-templates/georgia/modern-resume-template-digital-marketer.png"
              loading="lazy"
              sx={{ display: 'block' }}
            />
          </LinkUnstyled>
        </CardContent>
      </Card>

      <Card column={[12, 6]} isDark sx={{ background: '#3B4DEF' }}>
        <CardHeader>
          <CardHeading>Simple</CardHeading>
          <LinkArrow
            href="/resume-templates/simple"
            sx={{ color: 'text' }}
            arrowColor="text"
          >
            View simple templates
          </LinkArrow>
        </CardHeader>
        <CardContent sx={{ pb: 0, pt: 16 }}>
          <LinkUnstyled href="/resume-templates/simple">
            <CImage
              alt={`Simple ${activeGroup.menuTitle} resume template`}
              htmlWidth={1800}
              htmlHeight={1467}
              sizes="(max-width: 768px) 100vw, (max-width: 1440px) 47vw, 684px"
              srcSetSizes={[375, 750, 1125, 1368]}
              id="resume-templates/sidney/professional-resume-template-software-engineer.png"
              loading="lazy"
              sx={{ display: 'block' }}
            />
          </LinkUnstyled>
        </CardContent>
      </Card>
    </CardContainer>
  );
}
